import moment from "moment";

export default {
  get_now_utc() {
    return moment.utc().format("YYYY-MM-DD HH:mm:ss");
  },
  format_date_to_utc(date) {
    return moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
  },
};
